import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, concatMap, map } from 'rxjs/operators';
import { STORAGE_KEYS } from '../../enums/commission';
import { UserInfo } from '../../models/user/user-info';
import { HTTPUtilsSSO } from '../../network/http-sso';
import { CommissionsFormService } from '../commissions-table/commissions-form.service';
import { environment } from '../../../environments/environment';
import { extractSessionIdFromJWT, isJwtExpired } from '../../utils/commons-utilis';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private httpUtlis: HTTPUtilsSSO = new HTTPUtilsSSO(this.http);

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private commisionsFormService: CommissionsFormService
  ) {}

  isLogged: boolean = false;

  public initiateLogin(): void {
    // First get Cognito ID token, then fetch login URL
    this.httpUtlis.getIDToken().subscribe({
      next: (responseF) => {
        const idToken = responseF['AuthenticationResult']['IdToken'];
        localStorage.setItem(STORAGE_KEYS.ID_TOKEN, idToken);
        
        // Now call getLoginUrl with the ID token in headers
        this.httpUtlis.getLoginUrl().subscribe({
          next: (response) => {
            if (response.loginUrl) {
              window.location.href = response.loginUrl;
            }
          },
          error: (error) => {
            console.error('Failed to get login URL:', error);
          },
        });
      },
      error: (error) => {
        console.error('Failed to get Cognito token:', error);
      },
    });
  }

  public getToken(code?: string, state?: string): Observable<any> {
    // ID token already stored by initiateLogin(), just use it
    return this.httpUtlis.getAccessToken(code, state).pipe(
      concatMap((response) => {
        localStorage.setItem(
          STORAGE_KEYS.ACCESS_TOKEN,
          response['access_token']
        );

        return this.getUserInfo().pipe(
          map((response) => {
            localStorage.setItem(
              STORAGE_KEYS.USER_INFO,
              JSON.stringify(response)
            );
          })
        );
      }),
      catchError((error) => {
        return error;
      })
    );
  }

  public getUserInfo(): Observable<UserInfo> {
    return this.http
      .get<UserInfo>(environment.USER_INFO_URL, {
        headers: {
          Authorization: `Bearer ${
            localStorage.getItem(STORAGE_KEYS.ID_TOKEN) ?? ''
          }`,
          CustomHeader: `Bearer ${
            localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN) ?? ''
          }`,
        },
        params: {},
      })
      .pipe(
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

  public logout(): void {
    const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    const sessionId = extractSessionIdFromJWT(token);
    this.httpUtlis.logoutUser(sessionId).subscribe({
      next: () => {
        localStorage.clear();
        sessionStorage.clear();
        this.isLogged = false;
        this.cookieService.delete('iPlanetDirectoryPro', '/', window.location.hostname);
        this.cookieService.delete('iPlanetDirectoryPro', '/', 'gruppoitas.it');
        this.initiateLogin();
      },
      error: (error) => {
        console.error('Logout failed:', error);
        // Clear session even if logout call fails
        localStorage.clear();
        sessionStorage.clear();
        this.isLogged = false;
        this.cookieService.delete('iPlanetDirectoryPro', '/', window.location.hostname);
        this.cookieService.delete('iPlanetDirectoryPro', '/', 'gruppoitas.it');
        this.initiateLogin();
      },
    });
  }
}
